import Card from 'components/card';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { BsPlusCircleFill } from 'react-icons/bs';
import { MdDeleteForever, MdEditNote } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { PartyTypeAddMasterError, PartyTypeDeleteMaster, PartyTypeDeleteMasterError } from '../../../../Redux/Master/action';
import { GetParty } from '../../../../Redux/Party/action';
import Partyaddmodal from './partyaddmodal';

function PartyType() {

    const [open, setOpen] = useState(false);
    const [ModalOpen, setModalOpen] = useState(false)
    const [Editvalue, setEditvalue] = useState();
     const dispatch =useDispatch()
    const TempleId = JSON.parse(localStorage.getItem('Sopanam_TempleId'));
    const GetPartyData = useSelector((state) => state.Party.GetPartyData);
    const addpartytype =useSelector((state)=>state.Master.Partytypeadd)
    const delpartytype =useSelector((state)=>state.Master.Partytypedelete)
    
   

useEffect(()=>{
    dispatch(GetParty({TempleId:TempleId}))
},[addpartytype,delpartytype])

useEffect(() => {
  if (addpartytype?.Id > 0 && addpartytype.type == 1) {
    toast.success(" Party Type added successfully");
    setModalOpen(false)
    dispatch(PartyTypeAddMasterError());
  }else if(addpartytype.type == 2 && addpartytype.Id > 0){
    toast.success(" Party Type details updated successfully");
    dispatch(PartyTypeAddMasterError());
  }
  else if(delpartytype.Id>0 ){
    toast.success(" Party Type details delete successfully");
    dispatch(PartyTypeDeleteMasterError())
  }
}, [addpartytype]);

  return (
<div className='mt-5'>
{
    ModalOpen ?(
        <Partyaddmodal setModalOpen={setModalOpen} ModalOpen={ModalOpen} Editvalue={Editvalue} />

    ):""
}
    <Card extra={"w-full h-full p-4"}>
      <div className="relative flex items-center justify-between ">
        <div className="pb-5 text-xl font-bold text-navy-700 dark:text-white">
           PARTY TYPE
        </div>
        <div>
          {" "}
          <button
            data-modal-target="crud-modal"
            data-modal-toggle="crud-modal"
            onClick={() =>{
              setEditvalue("")
              setOpen(!open)
            }
            }
            open={open}
            className={`flex items-center text-xl hover:cursor-pointer ${
              // transparent
              // "bg-none text-white hover:bg-none active:bg-none"
              "mb-2 mr-5 bg-lightPrimary p-2 text-brand-green hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
            } linear justify-center rounded-lg font-bold transition duration-200`}
          >
            <BsPlusCircleFill onClick={()=>{setModalOpen(true)}} className="h-6 w-6" />
          </button>
        </div>
      </div>

      <div className="h-full md:h-[585px] md:overflow-y-auto ">
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-left text-sm text-black-500 rtl:text-right dark:text-black-400">
            <thead className="bg-gray-50 text-xs uppercase text-black-700 dark:bg-black-700 dark:text-black-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Sl No
                </th>
                <th scope="col" className="px-6 py-3">
                  Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Code
                </th>
                <th scope="col" className="px-6 py-3">
                      Action
                    </th>
              </tr>
            </thead>
            <tbody>
            {Array.isArray(GetPartyData) && GetPartyData.length ? GetPartyData.map((item, i) => (
    <tr key={i}>
        <td className="px-6 py-4 ">{i + 1}</td>
        <td className="px-6 py-4 ">{item.Name}</td>
        <td className="px-6 py-4 ">{item.Code}</td>
        <td className="px-6 py-4 whitespace-nowrap">
                       <button
                            type="button"
                            className="text-green-600  mr-5 "
                            onClick={() =>{
                              setEditvalue(item)
                              setModalOpen(true)
                            }
                            }
                          >
                            <MdEditNote
                              className="mt-1"
                              style={{ fontSize: "1.5rem" }}
                            
                              />
                          </button>
              <button
              type="button"
                className="text-red-600 hover:text-red-900"
                onClick={() => {
                 dispatch(PartyTypeDeleteMaster({
                  Pid:item.Id,
                  TempleId:TempleId
                 }))
                }}
              >
                <MdDeleteForever className="mt-1" style={{ fontSize: "1.5rem" }} />
              </button>
             

            </td>
    </tr>
)):<div className="items-center"> No Data Found</div>}
               
            </tbody>
          </table>
        </div>
      </div>
    </Card>
    </div>
  )
}

export default PartyType